import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createList } from "common/apis/savedplaces";
import { Storage } from "common/storage";

export function useCreateList() {
  const accessToken = Storage.getCurrentUserToken();
  const queryClient = useQueryClient();

  const { mutate, data, error, status } = useMutation({
    mutationFn: ({ name, venueId }: { name: string; venueId: number }) => {
      return createList(accessToken || "", name, venueId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["getAllSavedPlaces"],
        exact: false,
      });
    },
  });

  return {
    createList: mutate,
    result: data,
    error,
    status,
    isLoading: status === "pending",
  };
}
